import React, { useEffect, useState } from "react";
import { Box, Dialog, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const ImageFullscreenDialog = ({ open, images = [], initialIndex = 0, onClose }) => {
  const [index, setIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) {
      setIndex(initialIndex);
    }
  }, [open, initialIndex]);

  const safeImages = images.filter(Boolean);
  const hasMultiple = safeImages.length > 1;
  const currentImage = safeImages[index] || "";

  const handlePrev = () => {
    setIndex((prev) => (prev === 0 ? safeImages.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % safeImages.length);
  };

  if (!open || !safeImages.length) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          bgcolor: "rgba(0,0,0,0.92)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1.5,
          }}
        >
          <IconButton
            onClick={onClose}
            aria-label="close"
            sx={{
              color: "#fff",
              bgcolor: "rgba(255,255,255,0.12)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
            }}
          >
            <X size={20} />
          </IconButton>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            px: { xs: 2, md: 8 },
            pb: 3,
          }}
        >
          {hasMultiple && (
            <IconButton
              onClick={handlePrev}
              aria-label="previous image"
              sx={{
                position: "absolute",
                left: { xs: 8, md: 24 },
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "rgba(255,255,255,0.15)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
              }}
            >
              <ChevronLeft size={22} />
            </IconButton>
          )}

          <Box
            component="img"
            src={currentImage}
            alt={`Image ${index + 1}`}
            sx={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />

          {hasMultiple && (
            <IconButton
              onClick={handleNext}
              aria-label="next image"
              sx={{
                position: "absolute",
                right: { xs: 8, md: 24 },
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "rgba(255,255,255,0.15)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
              }}
            >
              <ChevronRight size={22} />
            </IconButton>
          )}
        </Box>

        {hasMultiple && (
          <Box
            sx={{
              textAlign: "center",
              color: "rgba(255,255,255,0.8)",
              fontSize: 12,
              pb: 2,
            }}
          >
            {index + 1} / {safeImages.length}
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default ImageFullscreenDialog;
